import routes from './Inventory/Routes/Routes';

export default [...routes];
